import {openDialog} from 'platform/components';

import i18n from '@dms/i18n';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

import {TaskActivityLog} from '../components/TaskActivityLog/TaskActivityLog';

interface OpenTaskHistoryDialogProps extends RequiredTestIdProps {
  taskId: string;
}

/** Opens a task's history over the task dialog; closing it returns to the task. */
export function openTaskHistoryDialog(props: OpenTaskHistoryDialogProps) {
  openDialog(
    <TaskActivityLog taskId={props.taskId} data-testid={suffixTestId('history', props)} />,
    {
      'data-testid': suffixTestId('historyDialog', props),
      title: i18n.t('general.labels.history'),
      size: 'large',
    }
  );
}
